import { render } from "./EditEmployeeRequestsView.vue?vue&type=template&id=56c91bae&scoped=true"
import script from "./EditEmployeeRequestsView.vue?vue&type=script&lang=js"
export * from "./EditEmployeeRequestsView.vue?vue&type=script&lang=js"

import "./EditEmployeeRequestsView.vue?vue&type=style&index=0&id=56c91bae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c91bae"]])

export default __exports__